"use strict";
// What an admin's "send the link" button actually sent.
//
// There is one button per account (salesman, company, client, collaborator) and
// the account's own state picks the link behind it: an INVITATION while it has
// no password yet, a LOGIN link — a password-reset token — once it has one.
// Before this existed, an accepted invitation made the button a dead end
// ("invitation déjà envoyée"), which is precisely the moment someone who lost
// their mail asks for it again.
//
// Shared because it is a contract across the boundary: the backend returns
// `kind` from the four send actions, the UI names what went out.
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountLinkSentMessage = exports.ACCOUNT_LINK_KIND = void 0;
const ACCOUNT_LINK_KIND_LITERAL = {
    /** First password: the invitation mail, minted or rotated. */
    INVITATION: 'invitation',
    /** Already onboarded: a connection link, so they can sign in again. */
    LOGIN: 'login',
};
exports.ACCOUNT_LINK_KIND = ACCOUNT_LINK_KIND_LITERAL;
/**
 * What to tell the admin who pressed the button. An unknown/absent `kind`
 * falls back to the invitation wording — the older, broader message — rather
 * than claiming something the server did not report.
 */
const accountLinkSentMessage = (kind) => kind === exports.ACCOUNT_LINK_KIND.LOGIN
    ? 'Lien de connexion envoyé.'
    : 'Invitation envoyée.';
exports.accountLinkSentMessage = accountLinkSentMessage;
//# sourceMappingURL=account-link.js.map